
namespace RioERP.Inventory {

    @Serenity.Decorators.registerClass()
    export class BookInwardDialog extends Serenity.EntityDialog<BookInwardRow, any> {
        protected getFormKey() { return BookInwardForm.formKey; }
        protected getIdProperty() { return BookInwardRow.idProperty; }
        protected getLocalTextPrefix() { return BookInwardRow.localTextPrefix; }
        protected getNameProperty() { return BookInwardRow.nameProperty; }
        protected getService() { return BookInwardService.baseUrl; }
        protected getDeletePermission() { return BookInwardRow.deletePermission; }
        protected getInsertPermission() { return BookInwardRow.insertPermission; }
        protected getUpdatePermission() { return BookInwardRow.updatePermission; }

        protected form = new BookInwardForm(this.idPrefix);

    }
}